let adminPatientsCache = null;
let lastFetched = 0;

export const getAdminPatientsCache = () => adminPatientsCache;

export const setAdminPatientsCache = (data) => {
  adminPatientsCache = data;
  lastFetched = Date.now();
};

export const updateAdminPatientInCache = (patientId, updater) => {
  if (!adminPatientsCache || !patientId || typeof updater !== "function") {
    return adminPatientsCache;
  }

  adminPatientsCache = {
    ...adminPatientsCache,
    patients: (adminPatientsCache.patients || []).map((patient) =>
      patient?._id === patientId ? updater(patient) : patient
    ),
  };
  lastFetched = Date.now();

  return adminPatientsCache;
};

export const clearAdminPatientsCache = () => {
  adminPatientsCache = null;
  lastFetched = 0;
};

export const isAdminPatientsCacheValid = (maxAge = 30000) => {
  return Date.now() - lastFetched < maxAge;
};
